import { object, oneOf, string } from 'prop-types'
import { Size } from '@opallabs/gem'
import Uploader from '.'

const ButtonUploader = (props) => <Uploader {...props} type="button" />

ButtonUploader.propTypes = {
  htmlId: string,
  iconName: string,
  iconStyles: object,
  promptText: string,
  theme: oneOf(['dark', 'light']),
}

ButtonUploader.defaultProps = {
  iconName: 'gem-upload',
  iconStyles: {
    height: Size.Icon,
    width: Size.Icon,
  },
  promptText: 'Upload',
}

export default ButtonUploader
